import Seo from "@/components/Seo";
import { organizationSchema, listings, SITE_URL } from "@/data/listings";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import WhoWeAreSection from "@/components/WhoWeAreSection";
import ProjectsSection from "@/components/ProjectsSection";
import AboutSection from "@/components/AboutSection";
import FeaturesSection from "@/components/FeaturesSection";

import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import { useI18n } from "@/lib/i18n";
import { useEffect } from "react";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    ["What payment and financing options are available at Sohar Real Estate?", "We offer flexible payment options including cash payment, direct installments, and mortgage financing in partnership with approved banks in Saudi Arabia."],
    ["Where are Sohar Real Estate projects located?", "Our projects are located in Riyadh's finest districts such as Al Narjis and Al Qairawan — strategic locations close to essential services and major roads."],
    ["What are the expected delivery timelines?", "We commit to clear delivery schedules for each project. The expected delivery date is communicated at the time of contract."],
    ["Do you offer warranties on residential units?", "Yes, we offer comprehensive warranties covering waterproofing, plumbing, electrical, sanitary fixtures, woodwork, and elevators."],
    ["Can I visit a project before purchasing?", "Absolutely. Contact us to schedule a tour with one of our representatives."],
    ["Are the units suitable for investment?", "Yes, our projects are in high-demand locations ensuring excellent investment returns through rental or resale."],
  ].map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })),
};

const Index = () => {
  const { lang } = useI18n();

  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
    document.body.className = lang === "en"
      ? "bg-background text-foreground font-houstiq"
      : "bg-background text-foreground font-naskh";
  }, [lang]);

  return (
    <div className="min-h-screen">
      <Seo
        lang={lang === "en" ? "en" : "ar"}
        path={lang === "en" ? "/en" : "/"}
        title={lang === "en" ? "Sohar Real Estate | Luxury Homes in Riyadh" : "صحار العقارية | مشاريع سكنية فاخرة في الرياض"}
        description={lang === "en"
          ? "Sohar Real Estate develops luxury residential projects in Riyadh's finest districts — Adwar Al Narjis, Al Qairawan Villas, Al Narjis Villas."
          : "شركة صحار العقارية - نصنع لك حياة استثنائية بمشاريع سكنية فاخرة في الرياض. أدوار النرجس، فلل القيروان، فلل النرجس."}
        image="/og/home.jpg"
        jsonLd={[
          faqSchema,
          organizationSchema,
          {
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: lang === "en" ? "Sohar Real Estate Projects" : "مشاريع صحار العقارية",
            itemListElement: listings.map((l, i) => ({
              "@type": "ListItem",
              position: i + 1,
              url: `${SITE_URL}${l.path}`,
              name: lang === "en" ? l.nameEn : l.nameAr,
            })),
          },
        ]}
      />
      <Navbar />
      <HeroSection />
      <WhoWeAreSection />
      <ProjectsSection />
      <AboutSection />
      <FeaturesSection />
      
      <FAQSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Index;
